import queryString from 'query-string';
import pathToRegexp from 'path-to-regexp';

function loc2state(location, viewPatterns) {
  const path = location.pathname;
  const query = queryString.parse(location.search);
  for(let vPat of viewPatterns) {
    let paramKeys = [];
    let regexp = pathToRegexp(vPat, paramKeys);
    const match = regexp.exec(path);
    if(match) {
      let view = vPat;
      let state = {};
      for(let k in query) {
        state[k] = query[k];
      }
      for(let i = 0; i < paramKeys.length; i++) {
        state[paramKeys[i].name] = match[i + 1];
      }
      return {
        view,
        state,
      };
    }
  }  
  return {
    state: {},
  };  
}

function state2loc(view, state) {
  let paramKeys = [];
  const regexp = pathToRegexp(view, paramKeys);
  paramKeys = paramKeys.map(pk => pk.name);
  const toPath = pathToRegexp.compile(view);
  const targetUrl = toPath(state);
  let query = {};
  for(let specKey in state) {
    if(paramKeys.indexOf(specKey) === -1) {
      query[specKey] = state[specKey];
    }
  }
  const targetSearch = queryString.stringify(query);
  return {
    pathname: targetUrl,
    search: targetSearch,
  }; 
}

export class Scene {
  constructor(history, viewPatterns) {
    this._history = history;
    this._viewPatterns = viewPatterns;
  }

  getCurrentState(viewPatterns) {
    return loc2state(this._history.location, viewPatterns || this._viewPatterns);
  }

  _pushState(view, state) {
    const location = state2loc(view, state);
    this._history.push(location);
  }

  _replaceState(view, state) {
    const location = state2loc(view, state);
    this._history.replace(location);
  }

  push(view, state) {
    this._pushState(view, state);
  }

  replace(view, state) {
    this._replaceState(view, state);
  }

  pushMerged(view, state) {
    const cState = this.getCurrentState();
    this.push(view, {...cState.state, ...state});
  }

  replaceMerged(view, state) {
    const cState = this.getCurrentState();
    this.replace(view, {...cState.state, ...state});
  }
}


// WEBPACK FOOTER //
// ./src/model/Scene.js